export const PERMISSIONS_ON_DELETE_REQUESTED = 'PERMISSIONS_ON_DELETE_REQUESTED';
export const PERMISSIONS_ON_DELETE_SUCCEEDED = 'PERMISSIONS_ON_DELETE_SUCCEEDED';
export const PERMISSIONS_ON_DELETE_FAILED = 'PERMISSIONS_ON_DELETE_FAILED';

export const PERMISSIONS_ON_GET_ALL_REQUESTED = 'PERMISSIONS_ON_GET_ALL_REQUESTED';
export const PERMISSIONS_ON_GET_ALL_SUCCEEDED = 'PERMISSIONS_ON_GET_ALL_SUCCEEDED';
export const PERMISSIONS_ON_GET_ALL_FAILED = 'PERMISSIONS_ON_GET_ALL_FAILED';

export const PERMISSIONS_ON_GET_ONE_REQUESTED = 'PERMISSIONS_ON_GET_ONE_REQUESTED';
export const PERMISSIONS_ON_GET_ONE_SUCCEEDED = 'PERMISSIONS_ON_GET_ONE_SUCCEEDED';
export const PERMISSIONS_ON_GET_ONE_FAILED = 'PERMISSIONS_ON_GET_ONE_FAILED';

export const PERMISSIONS_ON_SAVE_REQUESTED = 'PERMISSIONS_ON_SAVE_REQUESTED';
export const PERMISSIONS_ON_SAVE_SUCCEEDED = 'PERMISSIONS_ON_SAVE_SUCCEEDED';
export const PERMISSIONS_ON_SAVE_FAILED = 'PERMISSIONS_ON_SAVE_FAILED';
